import { render, staticRenderFns } from "./vManageCustomerModal.vue?vue&type=template&id=21e419fb&scoped=true"
import script from "./vManageCustomerModal.vue?vue&type=script&lang=ts"
export * from "./vManageCustomerModal.vue?vue&type=script&lang=ts"
import style0 from "./vManageCustomerModal.vue?vue&type=style&index=0&id=21e419fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e419fb",
  null
  
)

export default component.exports